import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topBar" }
const _hoisted_2 = { class: "openMenus" }
const _hoisted_3 = { class: "backto" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "panel_left" }
const _hoisted_6 = { class: "panel_right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_setting = _resolveComponent("setting")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Postcard = _resolveComponent("Postcard")!
  const _component_document = _resolveComponent("document")!
  const _component_User = _resolveComponent("User")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_Position = _resolveComponent("Position")!
  const _component_Mug = _resolveComponent("Mug")!
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          icon: _ctx.Expand,
          size: "large",
          circle: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.isCollapse = !this.isCollapse))
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_component_router_link, { to: '/list' }, {
          default: _withCtx(() => [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("edit.backContent")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_menu, {
          "default-active": "1",
          class: "el-menu-vertical-demo",
          collapse: _ctx.isCollapse,
          onOpen: _ctx.handleOpen,
          onClose: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/cover'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "1" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit.menu.coverSetting")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_setting)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/background'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "2" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit.menu.storyBackground")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Postcard)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/content'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "3" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit.menu.contentEdit")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_document)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            (_ctx.multiplePlayer)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: '/edit/' + _ctx.gameId + '/role'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "4" }, {
                      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" 角色管理 ", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_User)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/integral'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "5" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit.menu.pointManagement")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Coin)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/release'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "6" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit.menu.published")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Position)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/gameReview'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "7" }, {
                  title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" 游戏复盘 ", -1)
                  ]))]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Mug)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: '/edit/' + _ctx.gameId + '/questionnaires'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "8" }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("edit.menu.questionnaire")), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DocumentCopy)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["collapse", "onOpen", "onClose"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_scrollbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, { class: "rv" })
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}